module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DE79_1SF_H2X.276dbee5.jpg";